import { render, staticRenderFns } from "./PatientOrders.vue?vue&type=template&id=9641dd10&"
import script from "./PatientOrders.vue?vue&type=script&lang=js&"
export * from "./PatientOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports